import React, { useEffect, useRef, useState } from 'react';
import { Room, RoomEvent, Track } from 'livekit-client';
import { LiveKitRoom } from '@livekit/components-react';
import ChatRoom from './ChatRoom';
import ButtonBase from './buttons/ButtonBase';
import VideoConferenceStudent from './CustomVideoConference';

import { useLocation, useNavigate } from 'react-router-dom';
import DownloadButton from './buttons/DownloadButton';
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import SetUserNameModal from './SetUserNameModal';


const VideoStreaming = ({ token, url, updateToken, streamInfo }) => {
  const roomRef = useRef(null);
  const [room, setRoom] = useState(null);
  const location = useLocation()
  const [loading, setLoading] = useState(true);
  const { ParagraphTitle, themeTitle, themeId, homeworkId } = location.state
  const navigate = useNavigate()
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [requireUserName, setRequireUserName] = useState(false);


  useEffect(() => {
    if (room) {
      console.log("🧪 Комната подключена:", room)
      window.room = room;
    }
  }, [room]);


  useEffect(() => {
    const isNowDesktop = window.innerWidth >= 768;
    setIsDesktop(isNowDesktop);
    setIsChatOpen(isNowDesktop); // ← вот это добавь
  }, []);


  // ✅ Управляем открытием чата в зависимости от ширины экрана
  useEffect(() => {
    const handleResize = () => {
      const isNowDesktop = window.innerWidth >= 768;
      setIsDesktop(isNowDesktop);
      // 👇 НЕ меняем isChatOpen здесь
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  useEffect(() => {
    const connectToRoom = async () => {
      const newRoom = new Room();

      newRoom.on(RoomEvent.TrackSubscribed, (track, publication, participant) => {
        if (track.kind === Track.Kind.Video) {
          // Handle video track
        } else if (track.kind === Track.Kind.Audio) {
          // Handle audio track
        }
      });

      newRoom.on(RoomEvent.DataReceived, (data, participant) => {
        // ...
      });

      try {
        await newRoom.connect(url, token);
        roomRef.current = newRoom;

        // 👇 Устанавливаем имя ТОЛЬКО после подключения
        const user = JSON.parse(localStorage.getItem('user') || '{}');

        const isEmpty = (v) => !v || v === '<nil>' || v === 'null' || v === 'undefined';

        if (isEmpty(user.first_name) || isEmpty(user.last_name)) {
          setRequireUserName(true);
          return;
        }



        setRoom(newRoom);
      } catch (e) {
        if (e.status && e.status === 401) {
          console.debug('given token is expired. recreating...')
          localStorage.removeItem('chat_token');
          await updateToken();
        }
      }
    };

    connectToRoom();

    return () => {
      if (roomRef.current) {
        roomRef.current.disconnect();
      }
    };
  }, [token, url, updateToken]);


  return (
      <div className="video-streaming-container grow flex flex-col">
        {requireUserName && (
            <SetUserNameModal onComplete={() => {
              setRequireUserName(false);
              window.location.reload(); // или перезапусти connectToRoom()
            }} />
        )}

        {room ? (
            <LiveKitRoom room={room} className="w-full flex flex-col md:flex-row grow md:gap-4 md:px-6 relative h-full">
            <div className="md:basis-[65%] grow h-[520px]">
                <div className="flex flex-col gap-4 sm:flex-col-reverse mt-8 ">
                  <VideoConferenceStudent />
                </div>
              {/* Чат для мобилки */}
              <div className={`flex flex-col grow min-h-0 w-full ${!isDesktop ? '' : 'hidden'}`}>
                <div className={`bg-[#E5D8FF] rounded-2xl border border-[#D0B8FF] p-4 flex flex-col transition-all duration-200 ${isChatOpen ? '' : 'hidden'}`}>
                  <ChatRoom
                      room={room}
                      isOpen={true} // пусть сам скрывает свои части
                      onClose={() => setIsChatOpen(false)}
                  />
                </div>
              </div>




              {/* Заголовки + кнопки */}
                <div
                    className={`
                    w-full px-2 mt-4 mb-4 gap-4
                    ${isChatOpen ? 'hidden md:flex' : 'flex'} flex-col
                  `}
                >



                  <div className="w-full flex flex-row justify-between items-center md:block">
                    <div className="flex-1 min-w-[200px]">
                      <h1 className="text-md lg:text-3xl font-bold">{themeTitle}</h1>
                      <h2 className="text-lg text-gray-500">{ParagraphTitle}</h2>
                    </div>

                    {!isChatOpen && (
                        <div className="md:hidden ml-2">
                          <ButtonBase
                              onClick={() => setIsChatOpen(true)}
                              className="text-xs lg:text-md px-4 py-2 rounded-full border border-[#6446C3] text-[#6446C3]"
                          >
                            чат
                          </ButtonBase>
                        </div>
                    )}
                  </div>


                  {/* Кнопки "скрипт", "конспект", "домашка" — всегда */}
                  <div className="flex items-center gap-2 flex-wrap mt-4 md:mt-0">
                    {streamInfo?.manual_pdf && (
                        <DownloadButton fileName="конспект" fileUrl={streamInfo.manual_pdf} />
                    )}
                    {streamInfo?.script_pdf && (
                        <DownloadButton fileName="скрипт" fileUrl={streamInfo.script_pdf} />
                    )}
                    {homeworkId && (
                        <ButtonBase
                            onClick={() =>
                                navigate(`/themes/${themeId}/homework`, { state: { homeworkId } })
                            }
                        >
                          Домашка
                        </ButtonBase>
                    )}
                  </div>
                </div>
              </div>

              {/* Чат (уже) */}
              {/* Чат ТОЛЬКО для десктопа */}
              {isChatOpen && (
                  <div className="hidden md:flex md:basis-[35%] h-auto md:max-w-[500px] md:shrink-0 flex-col mt-0 lg:mt-8">
                    <div className="h-full bg-[#E5D8FF] rounded-2xl border border-[#D0B8FF] p-4 flex flex-col">
                      <ChatRoom
                          room={room}
                          isOpen={isChatOpen}
                          onClose={() => setIsChatOpen(false)}
                      />
                    </div>
                  </div>
              )}

            </LiveKitRoom>
        ) : (
            <div className="loading-container">
              <LoadingSpinner isLoading={false} />
            </div>
        )}
      </div>
  );
};


export default VideoStreaming;
